// import { combineReducers } from 'redux';

// // reducer import
// import customizationReducer from './customizationReducer';

// // ==============================|| COMBINE REDUCER ||============================== //

// const reducer = combineReducers({
//     customization: customizationReducer
// });

// export default reducer;
import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import {persistReducer} from "redux-persist"
import { combineReducers } from "@reduxjs/toolkit";
import Payroll from "./index"

const persistConfig={
    key:"root",
    version:1,
    storage
}

const reducer = combineReducers({
    payroll: Payroll
});

const persistedReducer=persistReducer(persistConfig,reducer);

export const store = configureStore({
    reducer:persistedReducer
})